
AddPageSwapTriggerSwup(function() {
    if($('#swup').find('.visual-banner-mobile').is('.visual-banner-mobile')) {
        $('body').addClass('hasvisual');
        if($('body').hasClass('lang_nl') || $('body').hasClass('lang_nl')) {
            $('#wrapper').addClass('wrapper-nosidebar');
        }

    }
    else {
        $('body').removeClass('hasvisual');
        if(document.location.pathname == '/') {
            $('#wrapper').addClass('wrapper-nosidebar');
        }
        else if(
            ($('body').hasClass('lang_nl') ||
            $('body').hasClass('lang_nl')) &&
            !$('#swup').hasClass('container-full')
            ) {
            $('#wrapper').removeClass('wrapper-nosidebar');
        }
    }
});